import postcodeLookup from './postcodeLookup'
import regionMap from './regionMap'

import { addClass, removeClass } from './utils/index'

const initPostcodeLookup = (
  mappingUrl,
  postcodeInput,
  postcodeError,
  regionUrls,
) => {
  /**
   * Setup the postcode lookup on both the list and detail page.
   */
  if (!postcodeInput) return

  const lookup = postcodeLookup(mappingUrl)

  // Clear error message on input
  if (postcodeError)
    postcodeInput.addEventListener('input', () => {
      postcodeError.innerText = ''
    })

  // Perform lookup on submit
  postcodeInput.form.addEventListener('submit', (evt) => {
    evt.preventDefault()

    lookup.match(postcodeInput.value, (region) => {
      if (region) {
        // A match, go to the region page
        window.location.href = regionUrls[region]
      } else if (postcodeError) {
        // No match, show error text
        postcodeError.innerText = 'Geen wijk gevonden'
      }
    })
  })
}

const listPage = ({
  mappingUrl,
  postcodeInput,
  postcodeError,
  regionContainer,
  regionUrls,
  mapContainer,
  DEBUG = false,
}) => {
  /**
   * Setup the SMD contact list page.
   *
   * This function can only be called after the Google Maps API has loaded.
   */

  initPostcodeLookup(mappingUrl, postcodeInput, postcodeError, regionUrls)

  const map = regionMap(mapContainer, DEBUG)

  // Create a mapping so we can quickly find the correct
  // element for each region key.
  //
  // This is also a convenient place to bind event
  // handlers to each element.
  const regionElements = Array.prototype.reduce.call(
    regionContainer.querySelectorAll('[data-region-id]'),
    (accumulator, element) => {
      const region = element.getAttribute('data-region-id')

      element.addEventListener('mouseover', () => map.handlers.over(region))
      element.addEventListener('mouseout', () => map.handlers.out(region))

      accumulator[region] = element
      return accumulator
    },
    {},
  )

  // These event handlers are used for both the map
  // and the list of locations.
  map.handlers.over = (region) => {
    map.focusRegion(region)
    addClass(regionElements[region], 'active')
  }

  map.handlers.out = (region) => {
    map.blurRegion(region)
    removeClass(regionElements[region], 'active')
  }

  // Click a region in the map and go to the correct page.
  map.handlers.click = (region) => {
    if (region in regionUrls) window.location.href = regionUrls[region]
  }
}

const detailPage = ({
  mappingUrl,
  postcodeInput,
  postcodeError,
  regionUrls,
  mapContainer,
  activeRegion,
  DEBUG = false,
}) => {
  /**
   * Setup the SMD contact detail page.
   *
   * This function can only be called after the Google Maps API has loaded.
   */

  initPostcodeLookup(mappingUrl, postcodeInput, postcodeError, regionUrls)

  const map = regionMap(mapContainer, DEBUG)

  map.hideRegions()
  if (activeRegion) map.showRegion(activeRegion)
}

export const contact = {
  listPage: listPage,
  detailPage: detailPage,
}
